import { message, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { forwardRef, useImperativeHandle, useState } from "react";
import { resolveFileTypes, validateFile } from "utilities/fileTypes";

const { Dragger } = Upload;

function DragUpload({ onFileChange, allowedTypes, maxSize }, ref) {
  const [fileList, setFileList] = useState([]);

  const { accept: acceptAttr } = resolveFileTypes(allowedTypes);

  useImperativeHandle(ref, () => ({
    reset: () => setFileList([]),
  }));

  const rejectFile = (file, error) => {
    message.error(error);
    setFileList([{ uid: file.uid, name: file.name, status: "error" }]);
    onFileChange(null, error);
  };

  const beforeUpload = (file) => {
    const error = validateFile(file, allowedTypes, maxSize);
    if (error) {
      rejectFile(file, error);
      return false;
    }

    setFileList([{ uid: file.uid, name: file.name, status: "done" }]);
    onFileChange(file);
    return false;
  };

  const handleRemove = () => {
    setFileList([]);
    onFileChange(null);
  };

  return (
    <Dragger
      name="file"
      multiple={false}
      // accept={acceptAttr}
      maxCount={1}
      fileList={fileList}
      onRemove={handleRemove}
      beforeUpload={beforeUpload}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        Click or drag file to this area to upload
      </p>
    </Dragger>
  );
}

export default forwardRef(DragUpload);
